// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MainComponente styles */
.styles_actionBarSticky__1jtHW {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #e0e7ff;
  padding: 0.75rem 1.25rem;
  z-index: 1000;
}

.styles_actionContainer__verbas__7ptRh {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles_backActions__actionContainer__VKsGP {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* ModalFiltrosComplexos styles */
.styles_modalTitle__z00bV {
  background: white;
  border-bottom: 1px solid #e0e7ff;
  padding: 0.75rem 1.25rem;
  position: relative;
}

.styles_titleContainer__MT26E {
  display: flex;
  align-items: center;
}

.styles_modalContent__g\\+9gI {
  padding: 1rem 1.25rem;
  background-color: #fff;
  min-height: 200px;
}

.styles_filtrosContainer__wZlOc {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.styles_emptyState__xw6sL {
  text-align: center;
  padding: 1.5rem 1rem;
  background: white;
  border-radius: 6px;
  border: 2px dashed #e0e7ff;
}

.styles_filtroRow__XYu6r {
  padding: 0.1rem 0.5rem;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  transition: background-color 0.2s ease;
}

.styles_filtroRow__XYu6r:hover {
  background-color: #f5f5f5;
}

/* .filtroHeader removido - não usado mais */

.styles_addFilterContainer__qnBq4 {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
}

.styles_modalActions__UoX4i {
  padding: 0.75rem 1.25rem !important;
  background: white;
  border-top: 1px solid #e0e7ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin: 0 !important;
}

.styles_buttonGroupLeft__xbt9u {
  display: flex;
  gap: 0.75rem;
  flex: 1 1;
  justify-content: flex-start;
  margin-left: 0;
}

.styles_buttonGroupRight__OhtKZ {
  display: flex;
  gap: 0.75rem;
  flex: 1 1;
  justify-content: flex-end;
  margin-right: 0;
}

.styles_btnFechar__jX9zh {
  color: #18316e !important;
  border: 1px solid #18316e !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  transition: all 0.3s ease !important;
}

.styles_btnFechar__jX9zh:hover {
  background-color: rgba(24, 49, 110, 0.04) !important;
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_btnAplicar__DMQFW {
  font-family: "Inter" !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  transition: all 0.3s ease !important;
}

/* Responsividade */
@media (max-width: 768px) {
  .styles_modalTitle__z00bV {
    padding: 0.5rem 1rem;
  }

  .styles_modalContent__g\\+9gI {
    padding: 0.75rem 1rem;
  }

  .styles_filtroRow__XYu6r {
    padding: 0.5rem;
  }

  .styles_modalActions__UoX4i {
    padding: 0.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Previa/ModalAnalisar/styles.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* MainComponente styles */\n.actionBarSticky {\n  position: sticky;\n  bottom: 0;\n  background: white;\n  border-top: 1px solid #e0e7ff;\n  padding: 0.75rem 1.25rem;\n  z-index: 1000;\n}\n\n.actionContainer__verbas {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.backActions__actionContainer {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n/* ModalFiltrosComplexos styles */\n.modalTitle {\n  background: white;\n  border-bottom: 1px solid #e0e7ff;\n  padding: 0.75rem 1.25rem;\n  position: relative;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n}\n\n.modalContent {\n  padding: 1rem 1.25rem;\n  background-color: #fff;\n  min-height: 200px;\n}\n\n.filtrosContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 1.5rem 1rem;\n  background: white;\n  border-radius: 6px;\n  border: 2px dashed #e0e7ff;\n}\n\n.filtroRow {\n  padding: 0.1rem 0.5rem;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n  transition: background-color 0.2s ease;\n}\n\n.filtroRow:hover {\n  background-color: #f5f5f5;\n}\n\n/* .filtroHeader removido - não usado mais */\n\n.addFilterContainer {\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem 0;\n}\n\n.modalActions {\n  padding: 0.75rem 1.25rem !important;\n  background: white;\n  border-top: 1px solid #e0e7ff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0 !important;\n}\n\n.buttonGroupLeft {\n  display: flex;\n  gap: 0.75rem;\n  flex: 1;\n  justify-content: flex-start;\n  margin-left: 0;\n}\n\n.buttonGroupRight {\n  display: flex;\n  gap: 0.75rem;\n  flex: 1;\n  justify-content: flex-end;\n  margin-right: 0;\n}\n\n.btnFechar {\n  color: #18316e !important;\n  border: 1px solid #18316e !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  text-transform: uppercase !important;\n  transition: all 0.3s ease !important;\n}\n\n.btnFechar:hover {\n  background-color: rgba(24, 49, 110, 0.04) !important;\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.btnAplicar {\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  text-transform: uppercase !important;\n  transition: all 0.3s ease !important;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .modalTitle {\n    padding: 0.5rem 1rem;\n  }\n\n  .modalContent {\n    padding: 0.75rem 1rem;\n  }\n\n  .filtroRow {\n    padding: 0.5rem;\n  }\n\n  .modalActions {\n    padding: 0.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionBarSticky": `styles_actionBarSticky__1jtHW`,
	"actionContainer__verbas": `styles_actionContainer__verbas__7ptRh`,
	"backActions__actionContainer": `styles_backActions__actionContainer__VKsGP`,
	"modalTitle": `styles_modalTitle__z00bV`,
	"titleContainer": `styles_titleContainer__MT26E`,
	"modalContent": `styles_modalContent__g+9gI`,
	"filtrosContainer": `styles_filtrosContainer__wZlOc`,
	"emptyState": `styles_emptyState__xw6sL`,
	"filtroRow": `styles_filtroRow__XYu6r`,
	"addFilterContainer": `styles_addFilterContainer__qnBq4`,
	"modalActions": `styles_modalActions__UoX4i`,
	"buttonGroupLeft": `styles_buttonGroupLeft__xbt9u`,
	"buttonGroupRight": `styles_buttonGroupRight__OhtKZ`,
	"btnFechar": `styles_btnFechar__jX9zh`,
	"btnAplicar": `styles_btnAplicar__DMQFW`
};
export default ___CSS_LOADER_EXPORT___;
